__turbopack_context__.v({
  "service": "ServiceListItem-module-scss-module__z4q4xq__service",
  "serviceLink": "ServiceListItem-module-scss-module__z4q4xq__serviceLink",
  "servicesContainer": "ServiceListItem-module-scss-module__z4q4xq__servicesContainer",
});
